
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmhH_kRKXZt2gdTDeDm31k87qB9FNveXkYNWg1DqvdwYMeta } from "/vercel/path0/web/pages/index.vue?macro=true";
import { default as loginf8_458FmjWEZWgARd7Efu4L5LdNmTJqq0OTELKpt9XRGEMeta } from "/vercel/path0/web/pages/login.vue?macro=true";
import { default as termsjnJZF4H5OKWOtcHkLCisoP_45s0QQddsE5jq4wDMScxpMMeta } from "/vercel/path0/web/pages/terms.vue?macro=true";
import { default as privacytD437n_452DXuM7w3qctYAk3JbndQLX8Uhpry7wg6KNpYMeta } from "/vercel/path0/web/pages/privacy.vue?macro=true";
import { default as supportBRzBg_45CbprmhXcvmFroXg6_6ArZHgRATmXpceVoYpVAMeta } from "/vercel/path0/web/pages/support.vue?macro=true";
import { default as debug_45mapsDCrKNUyq43ItaOPkGEAmW8OJItYzYG_45RMRpghWcFI4MMeta } from "/vercel/path0/web/pages/debug-maps.vue?macro=true";
import { default as indexQ3XKRyjgRdwvjs_jGJy7EoF25WBFq3hCQxnZ_45F84m8EMeta } from "/vercel/path0/web/pages/about/index.vue?macro=true";
import { default as indexzt1aaQhsMs6lg5zoEb458tg_lIYVPljyEwr1PTxzkZkMeta } from "/vercel/path0/web/pages/areas/index.vue?macro=true";
import { default as new15QUalVYtHp9hkPl9_45p0hhleGT3H0fnN3AiYucqF3noMeta } from "/vercel/path0/web/pages/articles/new.vue?macro=true";
import { default as checkoutQBF9mSX_5OlZFLSpZxHa5zgQqLMimGgEKjdQXA5q_2kMeta } from "/vercel/path0/web/pages/pro/checkout.vue?macro=true";
import { default as index1dSbg5ctRwMzr11Sw29LlvG1drAzCj7x7EijKsdbe4UMeta } from "/vercel/path0/web/pages/account/index.vue?macro=true";
import { default as editFNLxD8n9EIV8uzPoZAVd5sVj5G1tNPIu54B0waLnEmQMeta } from "/vercel/path0/web/pages/articles/edit.vue?macro=true";
import { default as index_45Xn1FsPvs3L2O46v0rUAT8t8nLSVmnoLIVqt_45tAQIHQMeta } from "/vercel/path0/web/pages/explore/index.vue?macro=true";
import { default as deleteyvIX9AFBGT5yZ9cmXaKBtsK_45_SskPARe22rQA2Gqx7YMeta } from "/vercel/path0/web/pages/account/delete.vue?macro=true";
import { default as index1GOSfXCrmdbxJtdro6dl_3gaUPugRLP2vRm5Dn_t1RYMeta } from "/vercel/path0/web/pages/articles/index.vue?macro=true";
import { default as createUwpOO9qivOcJe3I_45RFbeazU5IR4OTzjKnfR7G_qotksMeta } from "/vercel/path0/web/pages/courses/create.vue?macro=true";
import { default as _91slug_93STeMi0_5GYrdgWvET_k1G0nuW_jMTf_45FEVoqEM39414Meta } from "/vercel/path0/web/pages/articles/[slug].vue?macro=true";
import { default as coursesZm6ziZon4O0UzK0iC7dpZvEslWrF60aRZNTME6kan8QMeta } from "/vercel/path0/web/pages/explore/courses.vue?macro=true";
import { default as _91areaSlug_9368jKuetvReAL_45sEthjtVK33vIXsFmETrczPGl9fUfIYMeta } from "/vercel/path0/web/pages/areas/[areaSlug].vue?macro=true";
import { default as authenticate_45appUMV2ne4CBZRd88_45jnH00YkmFJI7QE9A2lx1Ch9bnwRUMeta } from "/vercel/path0/web/pages/authenticate-app.vue?macro=true";
import { default as indexL3IWy3VlZSCKd6eUbfDJzfXyRbvimSlgVu3sW_45X26QsMeta } from "/vercel/path0/web/pages/runs/[runId]/index.vue?macro=true";
import { default as analyzei0Nt3m2yoozdacbUFYTWmUky3UqIFjtUCQ7yDxqHCLoMeta } from "/vercel/path0/web/pages/runs/[runId]/analyze.vue?macro=true";
import { default as indexd2SPTWnQT_45ZUuc6SFPRCgf_G46PCTtsW_ZidpOVqWN8Meta } from "/vercel/path0/web/pages/users/[userId]/index.vue?macro=true";
import { default as explore_45courses6dQb6MM_45LJELyae9SUHvLyrewq36umeV4CYvwFLekVUMeta } from "/vercel/path0/web/pages/about/explore-courses.vue?macro=true";
import { default as course_45requestsjDWw18UzWrGPAZ8hrM0F8WtpmGX6eKHT1_BGgds7HAkMeta } from "/vercel/path0/web/pages/admin/course-requests.vue?macro=true";
import { default as reset_45passwordQzkmPIFGh89FoUuaHsfbNhTG95hnUrImHNKoJE9r_452wMeta } from "/vercel/path0/web/pages/account/reset-password.vue?macro=true";
import { default as run4l3IHJV0Z7X_X980kFzTOJAU1UxXqyehBbfQZNOq11YMeta } from "/vercel/path0/web/pages/courses/[courseId]/run.vue?macro=true";
import { default as coursesB4KeXXdcEJdBRPC_TxYSXS3cyF37kG5I5M_VyF1lltkMeta } from "/vercel/path0/web/pages/users/[userId]/courses.vue?macro=true";
import { default as editH2Nz_45oFXtAMYK7fFKV6vJrOpg_45Tx3FgZrrwX2egBPy4Meta } from "/vercel/path0/web/pages/courses/[courseId]/edit.vue?macro=true";
import { default as indexLIAVt3RApHIB7gec_45S_45oZECCY_45QfjkwPp4LzhiGykjQMeta } from "/vercel/path0/web/pages/courses/[courseId]/index.vue?macro=true";
import { default as user_45settings_45playgroundx8OgQdeh1jWvVs3BmNKicEtCHcEynUfbgpjf3NqeyUAMeta } from "/vercel/path0/web/pages/user-settings-playground.vue?macro=true";
import { default as previewyKZzR8TpvaWkQKsIEtVKoDca5Y4ysdgD9au1Dr364HcMeta } from "/vercel/path0/web/pages/courses/[courseId]/preview.vue?macro=true";
import { default as LoggedInIndexyK4KeGZL1IVTpZUF_45RC483eF_6o5kOt_45Da_05euFuWQMeta } from "/vercel/path0/web/pages/courses/[courseId]/LoggedInIndex.vue?macro=true";
import { default as LoggedOutIndexEOWbX4vk_45lElfetq9iSMYo3ymuRGenAzjE5KI2iWzw0Meta } from "/vercel/path0/web/pages/courses/[courseId]/LoggedOutIndex.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexmhH_kRKXZt2gdTDeDm31k87qB9FNveXkYNWg1DqvdwYMeta || {},
    component: () => import("/vercel/path0/web/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginf8_458FmjWEZWgARd7Efu4L5LdNmTJqq0OTELKpt9XRGEMeta || {},
    component: () => import("/vercel/path0/web/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsjnJZF4H5OKWOtcHkLCisoP_45s0QQddsE5jq4wDMScxpMMeta || {},
    component: () => import("/vercel/path0/web/pages/terms.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacytD437n_452DXuM7w3qctYAk3JbndQLX8Uhpry7wg6KNpYMeta || {},
    component: () => import("/vercel/path0/web/pages/privacy.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: supportBRzBg_45CbprmhXcvmFroXg6_6ArZHgRATmXpceVoYpVAMeta || {},
    component: () => import("/vercel/path0/web/pages/support.vue")
  },
  {
    name: "debug-maps",
    path: "/debug-maps",
    meta: debug_45mapsDCrKNUyq43ItaOPkGEAmW8OJItYzYG_45RMRpghWcFI4MMeta || {},
    component: () => import("/vercel/path0/web/pages/debug-maps.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: indexQ3XKRyjgRdwvjs_jGJy7EoF25WBFq3hCQxnZ_45F84m8EMeta || {},
    component: () => import("/vercel/path0/web/pages/about/index.vue")
  },
  {
    name: "areas",
    path: "/areas",
    meta: indexzt1aaQhsMs6lg5zoEb458tg_lIYVPljyEwr1PTxzkZkMeta || {},
    component: () => import("/vercel/path0/web/pages/areas/index.vue")
  },
  {
    name: "articles-new",
    path: "/articles/new",
    component: () => import("/vercel/path0/web/pages/articles/new.vue")
  },
  {
    name: "pro-checkout",
    path: "/pro/checkout",
    component: () => import("/vercel/path0/web/pages/pro/checkout.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/vercel/path0/web/pages/account/index.vue")
  },
  {
    name: "articles-edit",
    path: "/articles/edit",
    meta: editFNLxD8n9EIV8uzPoZAVd5sVj5G1tNPIu54B0waLnEmQMeta || {},
    component: () => import("/vercel/path0/web/pages/articles/edit.vue")
  },
  {
    name: "explore",
    path: "/explore",
    meta: index_45Xn1FsPvs3L2O46v0rUAT8t8nLSVmnoLIVqt_45tAQIHQMeta || {},
    component: () => import("/vercel/path0/web/pages/explore/index.vue")
  },
  {
    name: "account-delete",
    path: "/account/delete",
    component: () => import("/vercel/path0/web/pages/account/delete.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: index1GOSfXCrmdbxJtdro6dl_3gaUPugRLP2vRm5Dn_t1RYMeta || {},
    component: () => import("/vercel/path0/web/pages/articles/index.vue")
  },
  {
    name: "courses-create",
    path: "/courses/create",
    component: () => import("/vercel/path0/web/pages/courses/create.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    meta: _91slug_93STeMi0_5GYrdgWvET_k1G0nuW_jMTf_45FEVoqEM39414Meta || {},
    component: () => import("/vercel/path0/web/pages/articles/[slug].vue")
  },
  {
    name: "explore-courses",
    path: "/explore/courses",
    component: () => import("/vercel/path0/web/pages/explore/courses.vue")
  },
  {
    name: "areas-areaSlug",
    path: "/areas/:areaSlug()",
    meta: _91areaSlug_9368jKuetvReAL_45sEthjtVK33vIXsFmETrczPGl9fUfIYMeta || {},
    component: () => import("/vercel/path0/web/pages/areas/[areaSlug].vue")
  },
  {
    name: "authenticate-app",
    path: "/authenticate-app",
    meta: authenticate_45appUMV2ne4CBZRd88_45jnH00YkmFJI7QE9A2lx1Ch9bnwRUMeta || {},
    component: () => import("/vercel/path0/web/pages/authenticate-app.vue")
  },
  {
    name: "runs-runId",
    path: "/runs/:runId()",
    component: () => import("/vercel/path0/web/pages/runs/[runId]/index.vue")
  },
  {
    name: "runs-runId-analyze",
    path: "/runs/:runId()/analyze",
    meta: analyzei0Nt3m2yoozdacbUFYTWmUky3UqIFjtUCQ7yDxqHCLoMeta || {},
    component: () => import("/vercel/path0/web/pages/runs/[runId]/analyze.vue")
  },
  {
    name: "users-userId",
    path: "/users/:userId()",
    component: () => import("/vercel/path0/web/pages/users/[userId]/index.vue")
  },
  {
    name: "about-explore-courses",
    path: "/about/explore-courses",
    meta: explore_45courses6dQb6MM_45LJELyae9SUHvLyrewq36umeV4CYvwFLekVUMeta || {},
    component: () => import("/vercel/path0/web/pages/about/explore-courses.vue")
  },
  {
    name: "admin-course-requests",
    path: "/admin/course-requests",
    meta: course_45requestsjDWw18UzWrGPAZ8hrM0F8WtpmGX6eKHT1_BGgds7HAkMeta || {},
    component: () => import("/vercel/path0/web/pages/admin/course-requests.vue")
  },
  {
    name: "account-reset-password",
    path: "/account/reset-password",
    component: () => import("/vercel/path0/web/pages/account/reset-password.vue")
  },
  {
    name: "courses-courseId-run",
    path: "/courses/:courseId()/run",
    meta: run4l3IHJV0Z7X_X980kFzTOJAU1UxXqyehBbfQZNOq11YMeta || {},
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/run.vue")
  },
  {
    name: "users-userId-courses",
    path: "/users/:userId()/courses",
    component: () => import("/vercel/path0/web/pages/users/[userId]/courses.vue")
  },
  {
    name: "courses-courseId-edit",
    path: "/courses/:courseId()/edit",
    meta: editH2Nz_45oFXtAMYK7fFKV6vJrOpg_45Tx3FgZrrwX2egBPy4Meta || {},
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/edit.vue")
  },
  {
    name: "courses-courseId",
    path: "/courses/:courseId()",
    meta: indexLIAVt3RApHIB7gec_45S_45oZECCY_45QfjkwPp4LzhiGykjQMeta || {},
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/index.vue")
  },
  {
    name: "user-settings-playground",
    path: "/user-settings-playground",
    component: () => import("/vercel/path0/web/pages/user-settings-playground.vue")
  },
  {
    name: "courses-courseId-preview",
    path: "/courses/:courseId()/preview",
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/preview.vue")
  },
  {
    name: "courses-courseId-LoggedInIndex",
    path: "/courses/:courseId()/LoggedInIndex",
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/LoggedInIndex.vue")
  },
  {
    name: "courses-courseId-LoggedOutIndex",
    path: "/courses/:courseId()/LoggedOutIndex",
    component: () => import("/vercel/path0/web/pages/courses/[courseId]/LoggedOutIndex.vue")
  }
]